import React, { useState } from 'react';
import { EmailSettings, DemoRequestSettings } from './../AkazioConfig';
import { GoogleAnalyticsUtils, Category } from '../analytics/GoogleAnalyticsUtils';
import { SyncOutlined } from '@ant-design/icons';
import styled from 'styled-components';
// import { ReCAPTCHA } from "react-google-recaptcha";
// //const grecaptchaObjectLazy = lazy(() => (window as any).grecaptcha);

export enum DemoFormPurpose {
	Sales = 'Sales',
	Support = 'Support',
}

const StyledForm = styled.form`
	width: 100%;
`;

const StyledInput = styled.input`
	width: calc(100% - 22px);
	min-width: 0;
	padding: 4px 11px;
	color: rgba(0, 0, 0, 0.65);
	font-size: 14px;
	line-height: 1.5715;
	background-color: #fff;
	background-image: none;
	border: 1px solid #d9d9d9;
	border-radius: 2px;
	margin: 0 0 12px;
	font-family: 'Montserrat', sans-serif;

	&[type='submit'] {
		width: 100%;
		background: #00a896;
		color: white;
		cursor: pointer;
	}
`;

const StyledTextArea = styled.textarea`
	width: calc(100% - 22px);
	min-width: 0;
	padding: 4px 11px;
	color: rgba(0, 0, 0, 0.65);
	font-size: 14px;
	line-height: 1.5715;
	background-color: #fff;
	background-image: none;
	border: 1px solid #d9d9d9;
	border-radius: 2px;
	margin: 0 0 12px;
	font-family: 'Montserrat', sans-serif;
	resize: none;
`;

const ErrorWrapper = styled.div`
	background: #ffbaba;
	color: #d8000c;
	padding: 15px;
	font-size: 16px;

	a {
		font-size: 16px;
		color: #00a896 ! @important;
	}
`;

type BookDemoFormProps = {
	onCompleteCallback: (success: boolean) => void;
	purpose: DemoFormPurpose;
};

type FormState = {
	name: string;
	company: string;
	email: string;
	phone: string;
	message: string;
};

const defaultFormState: FormState = {
	name: '',
	company: '',
	email: '',
	phone: '',
	message: '',
};

const BookDemoForm: React.FC<BookDemoFormProps> = (props) => {
	const [formState, setFormState] = useState(defaultFormState);
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<boolean>(false);

	const onSubmit = (event: any) => {
		onFinish();
		event.preventDefault();
	};

	const onFinish = () => {
		setError(false);
		setLoading(true);

		const template_params = {
			from_name: formState.name,
			company_name: formState.company,
			from_email: formState.email,
			phone_number: formState.phone,
			message_html: `[Purpose = ${props.purpose}]: ${formState.message}`,
		};

		const w = window as any;
		const ejs = w.emailjs as any;

		ejs.send(DemoRequestSettings.EmailJsServiceId, DemoRequestSettings.EmailJsTemplateId, template_params)
			.then((response: any) => {
				props.onCompleteCallback(true);
			})
			.catch((error: any) => {
				console.error(error);
				setError(true);
				GoogleAnalyticsUtils.ReportEvent(Category.RequestDemoError, 'Request failed');
				props.onCompleteCallback(false);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<>
			<StyledForm onSubmit={onSubmit}>
				<StyledInput
					type="text"
					placeholder="Name"
					required
					value={formState.name}
					onChange={(e) => {
						const name = e.target.value;
						setFormState((x) => ({ ...x, name }));
					}}
				/>
				<StyledInput
					type="text"
					placeholder="Company"
					required
					value={formState.company}
					onChange={(e) => {
						const company = e.target.value;
						setFormState((x) => ({ ...x, company }));
					}}
				/>
				<StyledInput
					type="email"
					placeholder="Email"
					required
					value={formState.email}
					onChange={(e) => {
						const email = e.target.value;
						setFormState((x) => ({ ...x, email }));
					}}
				/>
				<StyledInput
					type="tel"
					placeholder="Phone number (optional)"
					value={formState.phone}
					onChange={(e) => {
						const phone = e.target.value;
						setFormState((x) => ({ ...x, phone }));
					}}
				/>
				<StyledTextArea
					placeholder="Message (optional)"
					value={formState.message}
					onChange={(e) => {
						const message = e.target.value;
						setFormState((x) => ({ ...x, message }));
					}}
				/>
				{loading ? (
					<div style={{ textAlign: 'center' }}>
						<SyncOutlined spin /> Sending...
					</div>
				) : (
					<StyledInput type="submit" value="Send Message" />
				)}
			</StyledForm>
			{error && (
				<ErrorWrapper>
					Sorry - something went wrong. While we look into this please feel free to contact{' '}
					<a
						href={`mailto:${
							props.purpose === DemoFormPurpose.Sales
								? EmailSettings.SalesEmail
								: EmailSettings.SupportEmail
						}`}
					>
						{props.purpose === DemoFormPurpose.Sales
							? EmailSettings.SalesEmail
							: EmailSettings.SupportEmail}
					</a>{' '}
					directly.
				</ErrorWrapper>
			)}
		</>
	);
};

export default BookDemoForm;
